<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<main class="content-page bg-gray">
    @if (security.permitted('reports', 'integrations log', 'view')) {
    <div class="content p-1">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Integration Log Report</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="col-md-12 p-1">
            <div class="rounded">
                <div class="list-bar">
                    <form [formGroup]="form" class="form-row">
                        <div class="form-group col">
                            <date-span [verb]="'Occurred'" [default]="FILTER_SPAN_KEY" [min]="'today'" [max]="'quarter'" (chosen)="spanned($event)"></date-span>
                        </div>
                         <div class="form-group col">
                            <select class="form-control" name="setup" id="setup-filter" formControlName="setup">
                                <option value="0">All Setups</option>
                                @for (setup of setups; track setup.id) {
                                    <option value="{{setup.id}}">{{setup.name}}</option>
                                }
                            </select>
                        </div>
                    </form>
                </div>
                <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                    @if (entries) {
                    <table class="table table-sm table-hover table-striped table-responsive-sm" id="activityTable">
                        <thead>
                            <tr>
                                <th (click)="sort('saleDate')" class="sorted" scope="col">
                                    Occurred
                                    @if (sortedAsc('createdAt')) {
                                    <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                    }
                                    @if (sortedDesc('createdAt')) {
                                    <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                    }
                                </th>
                                <th scope="col">Provider</th>
                                <th scope="col">User</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                                <th scope="col">Related</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of entries; track entry.id) {
                            <tr class="clickable text-dark" (click)="view(entry)">
                                <td>{{entry.createdAt | date:'E MMM d, yyyy h:mm:ss a'}}</td>
                                <td>
                                    <div class="flex-start">
                                        <span class="material-icons">{{iconify(entry.category)}}</span>
                                        <div>
                                            {{entry.provider}}
                                            <p class="subtitle">{{entry.providerStatus}}</p>
                                        </div>
                                    </div>
                                </td>
                                 <td>{{entry.user}}</td>
                                <td>
                                    <div class="flex-start">
                                        <span class="pallette {{statusColor(entry.status)}}">&nbsp;</span>
                                        <div>
                                            {{entry.status}} {{entry.message}}
                                        </div>
                                    </div>
                                </td>
                                <td>{{entry.action}}</td>
                                <td>
                                    {{entry.contact || entry.lot || entry.corporation}}
                                    <p class="subtitle">{{entry.sourceTable || ''}} {{entry.primaryKeyId || ''}}</p>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
            </div>
            <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                {{words[language]['displayed']}}</p>
        </div>
    </div>
}
</main>

<button class="d-none" data-target="#integration-log-meta-view" data-toggle="modal" id="btn-toggle-integration-meta-view"></button>
<div class="modal fade" id="integration-log-meta-view" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="integrationLogMetaView">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Integration Log Entry</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                @if (viewable) {
                    <p class="text-muted endpoint">{{viewable.endpoint}}</p>
                }

                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="request-tab-link" data-toggle="tab" data-target="#request-tab" type="button" role="tab" aria-selected="true"><span class="material-icons">chevron_right</span> Request</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="response-tab-link" data-toggle="tab" data-target="#response-tab" type="button" role="tab" aria-selected="fasle"><span class="material-icons">chevron_left</span> Response</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="settings-tab-link" data-toggle="tab" data-target="#settings-tab" type="button" role="tab" aria-selected="false"><span class="material-icons">settings</span> Settings</button>
                    </li> 
                </ul>
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="request-tab" role="tabpanel">
                        @if (copied) {
                            <span class="material-icons-outlined copy" (click)="clip($event, 'request')">done_all</span>
                        }
                        @else {
                            <span class="material-icons-outlined copy" (click)="clip($event, 'request')">content_copy</span>
                        }

                        <div class="detail"><pre>{{request()}}</pre></div>
                    </div>
                    <div class="tab-pane fade" id="response-tab" role="tabpanel">
                        @if (copied) {
                            <span class="material-icons-outlined copy" (click)="clip($event, 'response')">done_all</span>
                        }
                        @else {
                            <span class="material-icons-outlined copy" (click)="clip($event, 'response')">content_copy</span>
                        }
                        
                        <div class="detail"><pre>{{response()}}</pre></div>
                    </div>
                    <div class="tab-pane fade" id="settings-tab" role="tabpanel">
                        <div class="detail"><pre>{{settings()}}</pre></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                @if (viewable) {
                    <p class="text-muted">{{viewable.createdAt | date:'E MMM d, yyyy h:mm:ss a'}}</p>
                }
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
